import React, { Component } from "react";
import "./gainloss-transaction-screen-common-modal.css";
import { inject, observer } from "mobx-react";
import { Form, Modal, Button } from "react-bootstrap";
import moment from "moment";

const RenderRow = (props) => {
  const rows = props.fieldNames.map((col, index) => {
    const row = (
      <td key={index} className="SubSystemVarianceAudit" >
        {/* <div style="word-break:break-all;"> */}
        {col === "updatedDate"? moment(props.data[col]).format('MM/DD/YYYY h:mm a')
         // :col ==='auditMessage'? {cellEditor:"agLargeTextCellEditor",cellEditorParams:{maxLength:1000,cols:50,rows:6}}
          :col === 'district'? props.division
           :col === 'system' ? props.system
           :col === 'subSystem' ? props.subSystem
          
          : props.data[col]}
           {/* </div> */}
           
      </td>
    );
    console.log("render row=",row)
    return row;
  
  });
  return rows;
};

@inject("CommonStore", "GainLossSubSystemVarianceDataStore")
@observer
class AuditModal extends Component {
  render() {
    return (
      <div style={{ zIndex: 1000 }}>
        <div className="modal-container" style={{ height: 250 }}>
          <Modal
            show={this.props.GainLossSubSystemVarianceDataStore.showAuditPopUp}
            onHide={() => {}}
            size="xl"
            centered
          >
            <Form>
              <Modal.Title>Audit History</Modal.Title>
              <Modal.Body>
                <div style={{ margin: "30px", marginTop: "30px" }}>
                  {this.props.GainLossSubSystemVarianceDataStore.headerNames
                    .length > 0 && (
                    <div 
                      style={{
                        width: "100%",
                        height: "375px",
                        overflow: "scroll",
                        //align:"left"
                        // table-layout: "fixed";
                        

                      }}
                    >
                      <table id="tableHeader">
                        <tbody>
                          <tr>{this.renderTableHeader()}</tr>
                          {this.renderTableData()}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  style={{ marginRight: "10px" }}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.GainLossSubSystemVarianceDataStore.showAuditPopUp = false;
                  }}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </div>
      </div>
    );
  }

  renderTableHeader() {
    return this.props.GainLossSubSystemVarianceDataStore.headerNames.map(
      (col, index) => {
        return (
          <th
            key={index}
            // style={{ width: col === "AuditMessage" ? "1600px" : "" }}
            style={{ width: col === "AuditMessage" ? "1600px" : col === "System" ? "1200px":col === "SubSystem" ? "1600px": "" }}
         
          >
            {col}
          </th>
        );
      }
    );
  }

  renderTableData = () => {
      console.log("inside audit model audit data=",this.props.GainLossSubSystemVarianceDataStore.auditData)
    return this.props.GainLossSubSystemVarianceDataStore.auditData.map(
      (auditRow, index) => {
        return (
          <tr key={index}>
            <RenderRow
              data={auditRow}
              fieldNames={this.props.GainLossSubSystemVarianceDataStore.fieldNames}
              division={this.props.GainLossSubSystemVarianceDataStore.selectedDivision.value}
               system={this.props.GainLossSubSystemVarianceDataStore.system}
               subSystem={this.props.GainLossSubSystemVarianceDataStore.subSystem}
            />
          </tr>
        );
      }
    );
  };
}
export default AuditModal;
